import * as React from 'react';
import { IUserSession } from './interfaces/IUserSession';

export interface SessionContextValue<T extends IUserSession> {
    session: T | null;
    setSession: (session: T | null) => void;
    signIn: () => void;
    signOut: () => void;
    isLoading: boolean;
}

export const SessionContext = React.createContext<SessionContextValue<IUserSession>>({
    session: null,
    setSession: () => { },
    signIn: () => {},
    signOut: () => {},
    isLoading: true,
});

export function useSession<T extends IUserSession>(): SessionContextValue<T> {
    return React.useContext(SessionContext as unknown as React.Context<SessionContextValue<T>>);
}